import { useSlackIntegration } from './useSlackIntegration';

export const useSlackReacji = () => {
  const { provider } = useSlackIntegration();
  return {
    emoji: provider?.emoji,
  };
};
